import React from 'react'

import { SectionContainer } from '../../layouts'
import {
  backgroundClassName,
  contentCotainer,
  ctaSectionContainer,
  fontColor,
  headingStyling,
} from './CtaSection.module.css'

const NewCtaSection = ({ component, slice }) => {
  const { ctacontainerwidth, ctaheading, ctakicker, ctasectioncta } = slice

  let ctaContent = ctasectioncta
  if (typeof ctasectioncta === 'string') {
    ctaContent = JSON.parse(ctasectioncta)
  }

  return (
    <SectionContainer
      backgroundClassName={backgroundClassName}
      component={component}
      containerwidth={ctacontainerwidth}
      cta={ctaContent}
      extraClassName={ctaSectionContainer}
      extraContentClassName={contentCotainer}
      extraHeadingClassName={fontColor}
      extraHeadingContainerClassName={headingStyling}
      extraKickerClassName={fontColor}
      heading={ctaheading}
      kicker={ctakicker}
      withCta
      withHeader
      withParagraph
    />
  )
}

export default NewCtaSection
